var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import "./loadingOverlay.css";
import Shimmer from "../shimmer/shimmer";
/**
 * Loading Overlay Component
 * This component provides a full-screen loading overlay to prevent users from seeing old data
 * while new profile data is being loaded.
 */
export default function LoadingOverlay(props) {
    console.log("🔄 LoadingOverlay render:", {
        isVisible: props.isVisible,
        message: props.message,
        timestamp: new Date().toISOString(),
    });
    if (!props.isVisible) {
        console.log("❌ LoadingOverlay: Not visible, returning null");
        return null;
    }
    console.log("✅ LoadingOverlay: Visible, rendering overlay");
    return (_jsx("div", __assign({ className: "loading-overlay" }, { children: _jsxs("div", __assign({ className: "loading-overlay-content" }, { children: [_jsx("div", __assign({ className: "loading-spinner" }, { children: _jsx(Shimmer, { className: "loading-shimmer" }) })), _jsx("p", __assign({ className: "loading-message" }, { children: props.message || "Loading profile data..." }))] })) })));
}
